/**
 * Formatting utilities for UiBlocks
 *
 * Pure functions for formatting prices and text.
 */

/**
 * Format price in Romanian locale (Lei)
 *
 * @param price - Price value in Lei
 * @returns Formatted price string (e.g., "1.234,56 Lei")
 */
export function formatPrice(price: number): string {
  return new Intl.NumberFormat('ro-RO', {
    style: 'currency',
    currency: 'RON',
  }).format(price)
}

/**
 * Calculate discount amount between regular and special price
 *
 * @param regularPrice - Original price
 * @param specialPrice - Discounted price (null/undefined means no discount)
 * @returns Discount amount (0 if no discount)
 */
export function calculateDiscount(
  regularPrice: number,
  specialPrice: number | null | undefined
): number {
  if (!specialPrice || specialPrice >= regularPrice) return 0
  return regularPrice - specialPrice
}

/**
 * Truncate text to max length with ellipsis
 *
 * @param text - Text to truncate
 * @param maxLength - Maximum length (default: 70)
 * @returns Truncated text with "..." if needed
 */
export function truncateText(text: string, maxLength = 70): string {
  if (text.length <= maxLength) return text
  return `${text.substring(0, maxLength - 3)}...`
}
